import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useCurrentUserMaybe } from "~/auth/CurrentUserContext"
import { serverSignOutPath, signInPath } from "~/common/paths"
import { useDocumentTitle } from "~/common/useDocumentTitle"
import { useHomePath } from "~/common/useHomePath"

export const AccountInactiveScreen = () => {
  useDocumentTitle("Account Inactive")
  const { currentUser, result } = useCurrentUserMaybe()
  const navigate = useNavigate()
  const homePath = useHomePath()
  useEffect(() => {
    if (result.loading) return
    if (!currentUser) navigate(signInPath({}))
    if (currentUser && !currentUser.discarded) navigate(homePath)
  }, [currentUser, result.loading, navigate, homePath])

  return (
    <div className="p-6 text-center">
      <div className="pb-6">Account inactive</div>
      <a href={serverSignOutPath({})}>Logout</a>
    </div>
  )
}
